(function () {
  'use strict';
  if (window.MDCAdvantage) return;
  var mdcLanguage = ((document.documentElement.lang || (window.Shopify && window.Shopify.locale) || 'fr').toLowerCase().split(/[-_]/)[0]);
  var mdcTranslations = {
    "en": {
      "Votre code ": "Your code ",
      "Les avantages disponibles sont confirmés au panier.": "Available benefits are confirmed in the cart.",
      "Cette offre est terminée.": "This offer has ended.",
      "Copier et appliquer le code ": "Copy and apply code ",
      " au panier": " to the cart",
      "Copier": "Copy",
      "Copié": "Copied",
      "Copié dans le presse-papiers": "Copied to clipboard",
      "Jusqu’au ": "Until ",
      "Validité du code en cours, heure de Paris. Échéance confirmée dans Shopify.": "Current code validity, Paris time. Expiry confirmed in Shopify.",
      "Application au panier…": "Applying to cart…",
      "Code copié. ": "Code copied. ",
      "Code enregistré": "Code saved",
      "Code transmis au panier": "Code sent to the cart",
      " ; la remise sera vérifiée après ajout des articles.": "; the discount will be checked after items are added.",
      "Code non applicable à ce panier. Vérifiez les conditions de la réduction.": "This code does not apply to this cart. Check the discount conditions.",
      "Code enregistré ; aucune remise supplémentaire n’est confirmée pour ce panier.": "Code saved; no additional discount is confirmed for this cart.",
      "Réduction appliquée au panier.": "Discount applied to the cart.",
      "Application au panier non confirmée. Réessayez ou saisissez le code au panier.": "Application to the cart was not confirmed. Try again or enter the code in the cart."
    },
    "ar": {
      "Votre code ": "رمزك ",
      "Les avantages disponibles sont confirmés au panier.": "يتم تأكيد المزايا المتاحة في السلة.",
      "Cette offre est terminée.": "انتهى هذا العرض.",
      "Copier et appliquer le code ": "نسخ الرمز وتطبيقه ",
      " au panier": " على السلة",
      "Copier": "نسخ",
      "Copié": "تم النسخ",
      "Copié dans le presse-papiers": "تم النسخ إلى الحافظة",
      "Jusqu’au ": "صالح حتى ",
      "Validité du code en cours, heure de Paris. Échéance confirmée dans Shopify.": "صلاحية الرمز الحالي بتوقيت باريس. تاريخ الانتهاء مؤكّد في Shopify.",
      "Application au panier…": "جارٍ التطبيق على السلة…",
      "Code copié. ": "تم نسخ الرمز. ",
      "Code enregistré": "تم حفظ الرمز",
      "Code transmis au panier": "تم إرسال الرمز إلى السلة",
      " ; la remise sera vérifiée après ajout des articles.": "؛ سيتم التحقق من الخصم بعد إضافة المنتجات.",
      "Code non applicable à ce panier. Vérifiez les conditions de la réduction.": "لا ينطبق هذا الرمز على هذه السلة. تحقّق من شروط الخصم.",
      "Code enregistré ; aucune remise supplémentaire n’est confirmée pour ce panier.": "تم حفظ الرمز؛ لم يتم تأكيد خصم إضافي لهذه السلة.",
      "Réduction appliquée au panier.": "تم تطبيق الخصم على السلة.",
      "Application au panier non confirmée. Réessayez ou saisissez le code au panier.": "لم يتم تأكيد تطبيق الرمز على السلة. حاول مجددًا أو أدخل الرمز في السلة."
    },
    "es": {
      "Votre code ": "Tu código ",
      "Les avantages disponibles sont confirmés au panier.": "Las ventajas disponibles se confirman en el carrito.",
      "Cette offre est terminée.": "Esta oferta ha finalizado.",
      "Copier et appliquer le code ": "Copiar y aplicar el código ",
      " au panier": " al carrito",
      "Copier": "Copiar",
      "Copié": "Copiado",
      "Copié dans le presse-papiers": "Copiado al portapapeles",
      "Jusqu’au ": "Hasta ",
      "Validité du code en cours, heure de Paris. Échéance confirmée dans Shopify.": "Validez del código actual, hora de París. Vencimiento confirmado en Shopify.",
      "Application au panier…": "Aplicando al carrito…",
      "Code copié. ": "Código copiado. ",
      "Code enregistré": "Código guardado",
      "Code transmis au panier": "Código enviado al carrito",
      " ; la remise sera vérifiée après ajout des articles.": "; el descuento se comprobará al añadir los artículos.",
      "Code non applicable à ce panier. Vérifiez les conditions de la réduction.": "Este código no se aplica a este carrito. Consulta las condiciones del descuento.",
      "Code enregistré ; aucune remise supplémentaire n’est confirmée pour ce panier.": "Código guardado; no se ha confirmado ningún descuento adicional para este carrito.",
      "Réduction appliquée au panier.": "Descuento aplicado al carrito.",
      "Application au panier non confirmée. Réessayez ou saisissez le code au panier.": "No se ha confirmado la aplicación al carrito. Inténtalo de nuevo o introduce el código en el carrito."
    }
  };
  function mdcText(text) {
    var translations = mdcTranslations[mdcLanguage];
    return translations && Object.prototype.hasOwnProperty.call(translations, text) ? translations[text] : text;
  }

  var snapshot = { config: { schemaVersion: 2, enabled: false }, country: '', productId: '' };
  var clockBase = 0;
  var clockStart = performance.now();
  var lastClockTime = 0;
  var refreshing = false;
  var updateTimer = 0;
  var applying = false;
  var feedback = { code: '', text: '' };
  function acceptSnapshot(value) {
    var time = new Date(value.serverTime).getTime();
    if (!Number.isFinite(time)) throw new Error('Missing server time');
    if (clockBase && time + 1500 < now().getTime()) throw new Error('Outdated server snapshot');
    snapshot = value;
    clockBase = time;
    clockStart = performance.now();
  }
  try { acceptSnapshot(JSON.parse(document.getElementById('MdcPromotionSyncConfig').textContent)); } catch (error) {}
  function now() {
    // A cached Liquid timestamp or a sleeping tab must not prolong a fixed offer.
    lastClockTime = Math.max(lastClockTime, Date.now(), clockBase + Math.max(0, performance.now() - clockStart));
    return new Date(lastClockTime);
  }
  function currentOffer(productId) {
    return window.MDCAdvantageModel.selectOffer(now(), snapshot.config, {
      country: snapshot.country, productId: productId || snapshot.productId
    });
  }
  function append(parent, tag, className, text) {
    var element = document.createElement(tag);
    element.className = className;
    if (text) element.textContent = text;
    parent.appendChild(element);
    return element;
  }
  function cartRoot() {
    return window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  }
  function preservePreview(url) {
    var theme = window.Shopify && window.Shopify.theme;
    if (!url.searchParams.has('preview_theme_id') && theme && theme.role === 'unpublished' &&
        Number.isSafeInteger(theme.id) && theme.id > 0) {
      url.searchParams.set('preview_theme_id', String(theme.id));
    }
    return url;
  }
  function isProductPage() {
    return document.body && document.body.classList.contains('mdc-maison-douce-product-top');
  }
  function setFeedback(code, message) {
    feedback = { code: code, text: message };
    if (isProductPage()) return;
    document.querySelectorAll('.mdc-advantage').forEach(function (element) {
      var status = element.querySelector('.mdc-z-promo__status');
      if (status && element.dataset.mdcCode === code) status.textContent = message;
    });
  }
  function setBusy() {
    document.querySelectorAll('.mdc-advantage .mdc-z-promo__copy').forEach(function (button) {
      button.disabled = applying;
      button.setAttribute('aria-busy', String(applying));
    });
  }
  function within(promise, milliseconds, fallback) {
    return new Promise(function (resolve) {
      var settled = false;
      var timer = window.setTimeout(function () { finish(fallback); }, milliseconds);
      function finish(value) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        resolve(value);
      }
      Promise.resolve(promise).then(finish, function () { finish(fallback); });
    });
  }
  function copyCode(code) {
    try {
      if (!navigator.clipboard || typeof navigator.clipboard.writeText !== 'function') return Promise.resolve(false);
      return within(navigator.clipboard.writeText(code).then(function () { return true; }), 1500, false);
    } catch (error) { return Promise.resolve(false); }
  }
  function matchingCode(value, code) {
    return typeof value === 'string' && value.trim().toUpperCase() === code.toUpperCase();
  }
  function appliedAmount(cart, code) {
    var amount = 0;
    (cart.cart_level_discount_applications || []).forEach(function (discount) {
      if (discount.type === 'discount_code' && matchingCode(discount.code || discount.title, code) &&
          Number.isSafeInteger(discount.total_allocated_amount) && discount.total_allocated_amount > 0) {
        amount += discount.total_allocated_amount;
      }
    });
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (allocation) {
        var discount = allocation.discount_application || {};
        if (discount.type === 'discount_code' && matchingCode(discount.code || discount.title, code) &&
            Number.isSafeInteger(allocation.amount) && allocation.amount > 0) amount += allocation.amount;
      });
    });
    return amount;
  }
  function snapshotAmount(html, cart, code) {
    if (typeof html !== 'string' || !html) return 0;
    try {
      var document = new DOMParser().parseFromString(html, 'text/html');
      var data = document.querySelector('[data-mdc-savings-snapshot]');
      if (!data) return 0;
      var value = JSON.parse(data.textContent);
      if (!value || value.currency !== cart.currency ||
          !Number.isSafeInteger(value.total_price) || value.total_price !== cart.total_price ||
          !Number.isSafeInteger(value.original_total_price) || value.original_total_price !== cart.original_total_price ||
          !Array.isArray(value.items) || value.items.length !== cart.items.length) return 0;
      var keys = new Set();
      var quantities = 0;
      for (var item of value.items) {
        if (!item || !item.key || keys.has(item.key) || !Number.isSafeInteger(item.quantity) || item.quantity < 1) return 0;
        var current = cart.items.find(function (line) { return line.key === item.key; });
        if (!current || current.quantity !== item.quantity || current.final_line_price !== item.final_line_price) return 0;
        keys.add(item.key);
        quantities += item.quantity;
      }
      if (quantities !== cart.item_count) return 0;
      var amount = appliedAmount(value, code);
      return amount > 0 && amount <= value.original_total_price - value.total_price ? amount : 0;
    } catch (error) { return 0; }
  }
  async function confirmedAmount(cart, code) {
    var amount = appliedAmount(cart, code);
    if (amount > 0) return amount;
    amount = snapshotAmount(cart.sections && cart.sections['mdc-cart-savings-data'], cart, code);
    if (amount > 0) return amount;
    try {
      var url = preservePreview(new URL(location.href));
      url.searchParams.delete('sections');
      url.searchParams.set('section_id', 'mdc-cart-savings-data');
      var response = await fetch(url.pathname + url.search, { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) return 0;
      return snapshotAmount(await response.text(), cart, code);
    } catch (error) { return 0; }
  }
  function sectionsToUpdate() {
    var sections = ['mdc-cart-savings-data'];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (component) {
      var id = component.dataset.sectionId;
      if (id && sections.indexOf(id) === -1 && sections.length < 5) sections.push(id);
    });
    return sections;
  }
  function refreshSavings() {
    try {
      if (window.MDCCartSavings && typeof window.MDCCartSavings.refresh === 'function') {
        return window.MDCCartSavings.refresh();
      }
    } catch (error) {}
    return Promise.resolve();
  }
  async function syncCart(cart, codes, code, applicable) {
    document.dispatchEvent(new CustomEvent('mdc:cart-updated', {
      detail: { cart: cart, code: code, applicable: applicable }
    }));
    var savings = within(refreshSavings(), 1500, null);
    try {
      var events = await within(import('@shopify/events'), 1500, null);
      if (events) {
        var eventCart = events.CartDiscountUpdateEvent.createCartFromAjaxResponse(cart);
        var deferred = events.CartDiscountUpdateEvent.createPromise();
        document.dispatchEvent(new events.CartDiscountUpdateEvent({
          discountCodes: codes.map(function (value) { return { code: value }; }),
          promise: deferred.promise
        }));
        deferred.resolve({
          cart: eventCart,
          detail: { sections: cart.sections, items: cart.items, itemCount: cart.item_count, source: 'mdc-advantage' }
        });
      }
    } catch (error) {}
    await savings;
  }
  function render(element, productId) {
    if (!element) return;
    element.classList.add('mdc-advantage');
    if (productId) element.dataset.productId = productId;
    var offer = currentOffer(element.dataset.productId);
    var displayOffer = Object.assign({}, offer);
    delete displayOffer.validUntil;
    var signature = JSON.stringify(displayOffer);
    if (element.dataset.mdcAdvantage === signature) return;
    element.dataset.mdcAdvantage = signature;
    element.replaceChildren();
    if (!offer.available) {
      delete element.dataset.mdcCode;
      append(element, 'p', 'mdc-advantage__neutral', mdcText(offer.message));
      return;
    }
    element.dataset.mdcCode = offer.code;
    if (!isProductPage()) {
      var status = append(element, 'span', 'mdc-z-promo__status');
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      if (feedback.code === offer.code) status.textContent = feedback.text;
    }
    var productPromo = isProductPage() && element.classList.contains('mdc-z-promo');
    var row = append(element, 'div', 'mdc-z-promo__row');
    append(row, 'span', 'mdc-z-promo__badge', (productPromo ? (mdcLanguage === 'fr' ? 'Votre code remise de ' : mdcText('Votre code ')) : '') + offer.discountLabel);
    var copy = append(row, 'button', 'mdc-z-promo__copy');
    copy.type = 'button';
    copy.disabled = applying;
    copy.setAttribute('aria-busy', String(applying));
    copy.setAttribute('aria-label', mdcText('Copier et appliquer le code ') + offer.code + mdcText(' au panier'));
    append(copy, 'strong', '', offer.code);
    var copyLabel = append(copy, 'span', 'mdc-z-promo__copy-label', mdcText('Copier'));
    var expiryLocale = ({ en: 'en-GB', ar: 'ar', es: 'es-ES' })[mdcLanguage] || 'fr-FR';
    var fullExpiry = mdcText('Jusqu’au ') + new Intl.DateTimeFormat(expiryLocale, { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23', timeZone: 'Europe/Paris' }).format(new Date(offer.validUntil)) + ' (Paris)';
    var expiry = append(row, 'time', 'mdc-advantage__expiry', productPromo ? '' : fullExpiry);
    if (productPromo) {
      append(expiry, 'span', 'mdc-advantage__expiry-prefix', mdcText('Jusqu’au '));
      append(expiry, 'span', '', new Intl.DateTimeFormat(expiryLocale, { day: '2-digit', month: '2-digit', timeZone: 'Europe/Paris' }).format(new Date(offer.validUntil)));
      expiry.setAttribute('aria-label', fullExpiry);
    }
    expiry.dateTime = offer.validUntil;
    expiry.title = productPromo ? fullExpiry : mdcText('Validité du code en cours, heure de Paris. Échéance confirmée dans Shopify.');
    var copyConfirmation = null;
    if (productPromo) {
      copyConfirmation = append(element, 'span', 'mdc-z-promo__copy-confirmation');
      copyConfirmation.setAttribute('role', 'status');
      copyConfirmation.setAttribute('aria-live', 'polite');
      copyConfirmation.setAttribute('aria-atomic', 'true');
    }
    var copyLabelTimer = 0;
    copy.addEventListener('click', async function (event) {
      event.preventDefault();
      event.stopPropagation();
      var active = currentOffer(element.dataset.productId);
      if (!active.available || active.code !== offer.code) { render(element); return; }
      if (copy.disabled || applying) return;
      applying = true;
      setBusy();
      var clipboard = copyCode(offer.code);
      if (isProductPage()) {
        clipboard.then(function (copied) {
          if (!copied) return;
          copyLabel.textContent = mdcText('Copié dans le presse-papiers');
          if (productPromo) row.classList.add('mdc-z-promo__row--copied');
          if (copyConfirmation) copyConfirmation.textContent = mdcText('Copié dans le presse-papiers');
          window.clearTimeout(copyLabelTimer);
          copyLabelTimer = window.setTimeout(function () {
            copyLabel.textContent = mdcText('Copier');
            row.classList.remove('mdc-z-promo__row--copied');
            if (copyConfirmation) copyConfirmation.textContent = '';
          }, 3500);
        });
      }
      setFeedback(offer.code, mdcText('Application au panier…'));
      try {
        var root = cartRoot();
        var response = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
        if (!response.ok) throw new Error('Cart unavailable');
        var cart = await response.json();
        if (!cart || !Array.isArray(cart.items) || !Number.isSafeInteger(cart.item_count)) throw new Error('Cart unavailable');
        var stillActive = currentOffer(element.dataset.productId);
        if (!stillActive.available || stillActive.code !== offer.code) {
          render(element);
          throw new Error('Offer expired before cart update');
        }
        var codes = window.MDCAdvantageModel.mergeCodes(cart.discount_codes, offer.code);
        var sections = sectionsToUpdate();
        var payload = { discount: codes.join(',') };
        if (sections.length) {
          var context = preservePreview(new URL(location.href));
          context.searchParams.delete('sections');
          context.searchParams.delete('section_id');
          payload.sections = sections;
          payload.sections_url = context.pathname + context.search;
        }
        response = await fetch(root + 'cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        });
        if (!response.ok) throw new Error('Discount unavailable');
        cart = await response.json();
        if (!cart || cart.errors || !Array.isArray(cart.items) || !Number.isSafeInteger(cart.item_count)) throw new Error('Discount unavailable');
        var recorded = (cart.discount_codes || []).find(function (entry) { return matchingCode(entry.code, offer.code); });
        var applicable = Boolean(recorded && recorded.applicable === true);
        var amount = applicable && cart.item_count > 0 ? await within(confirmedAmount(cart, offer.code), 5000, 0) : 0;
        var prefix = (await clipboard) ? mdcText('Code copié. ') : '';
        if (cart.item_count === 0) {
          setFeedback(offer.code, prefix + (recorded ? mdcText('Code enregistré') : mdcText('Code transmis au panier')) +
            mdcText(' ; la remise sera vérifiée après ajout des articles.'));
        } else if (!applicable) {
          setFeedback(offer.code, prefix + mdcText('Code non applicable à ce panier. Vérifiez les conditions de la réduction.'));
        } else if (amount === 0) {
          setFeedback(offer.code, prefix + mdcText('Code enregistré ; aucune remise supplémentaire n’est confirmée pour ce panier.'));
        } else {
          setFeedback(offer.code, prefix + mdcText('Réduction appliquée au panier.'));
        }
        await syncCart(cart, codes, offer.code, applicable);
      } catch (error) {
        var copied = await clipboard;
        setFeedback(offer.code, (copied ? mdcText('Code copié. ') : '') +
          mdcText('Application au panier non confirmée. Réessayez ou saisissez le code au panier.'));
        within(refreshSavings(), 1500, null);
      } finally { applying = false; setBusy(); }
    });
  }
  function updateAll() {
    document.querySelectorAll('.mdc-advantage').forEach(function (element) { render(element); });
  }
  function scheduleUpdate() {
    window.clearTimeout(updateTimer);
    updateAll();
    var current = now().getTime();
    // Use actual Shopify expiry, including non-midnight times; no rolling period.
    var delay = 60000 - (current % 60000);
    var offer = currentOffer();
    if (offer.available) delay = Math.min(delay, Math.max(1, Date.parse(offer.validUntil) - current));
    updateTimer = window.setTimeout(scheduleUpdate, delay);
  }
  async function refresh() {
    if (refreshing) return;
    refreshing = true;
    try {
      var url = preservePreview(new URL(location.href));
      url.searchParams.delete('sections');
      url.searchParams.set('section_id', 'mdc-advantage-data');
      url.searchParams.set('_mdc_promo_refresh', String(Date.now()));
      var response = await fetch(url.pathname + url.search, { credentials: 'same-origin', cache: 'no-store', signal: typeof AbortSignal !== 'undefined' && typeof AbortSignal.timeout === 'function' ? AbortSignal.timeout(10000) : undefined });
      if (!response.ok) throw new Error('Snapshot unavailable');
      var html = new DOMParser().parseFromString(await response.text(), 'text/html');
      var data = html.querySelector('[data-mdc-advantage-snapshot]');
      if (!data) throw new Error('Snapshot missing');
      acceptSnapshot(JSON.parse(data.textContent));
    } catch (error) {
      // A failed refresh never extends validUntil or authorizes a code.
    } finally { refreshing = false; scheduleUpdate(); }
  }
  window.MDCAdvantage = { currentOffer: currentOffer, render: render, refresh: refresh };
  // Re-read only this manual theme snapshot. This does not activate Promo Sync.
  window.setInterval(function () { if (!document.hidden) refresh(); }, 1800000);
  window.addEventListener('pageshow', function () { scheduleUpdate(); refresh(); });
  document.addEventListener('visibilitychange', function () { scheduleUpdate(); if (!document.hidden) refresh(); });
  scheduleUpdate();
}());



